import { createFileRoute } from '@tanstack/react-router'
import { requireActiveSubscription, requireRoles } from '@/lib/middleware'
import { PartnerTrainingEditorPage } from '@/features/partner-training/editor-page'

export const Route = createFileRoute('/_authenticated/_organization/partner/training/$templateId')({
  beforeLoad: async () => {
    await requireRoles(['owner', 'admin', 'team_leader', 'finance'])
    await requireActiveSubscription()
  },
  component: PartnerTrainingEditorPage,
})
